import React, { useEffect, useState } from 'react'
import { PropTypes } from 'prop-types'
import { useForm } from 'react-hook-form';
import { Redirect } from 'react-router-dom'
import { useSelector } from 'react-redux';
import ImageUploading from 'react-images-uploading';
import { Button, Card, Col, Container, Form, Row } from 'react-bootstrap'

import types from '../../types/types';
import { isEmail, isMobilePhone, regexUserName, regexStandardName, regexPassword } from '../../components/common/Util'
import { Loading } from '../../components/common/Loading';
import { PageHeaderStandar } from '../../components/common/PageHeaderStandar';
import { InputField } from '../../components/common/InputField';
import { ButtonsSaveAndCancel } from '../../components/common/ButtonsSaveAndCancel'
import SelectCombobox from '../../components/common/SelectCombobox';
import Checkbox from '../../components/common/Checkbox';
import ErrorMessage from '../../components/common/ErrorMessage';
import { useisLoading } from '../../hook/useisLoading';
import { message } from '../../components/common/Notification';
import { UsersAPI, User } from '../../components/apis';
import ImageLoader from './ImageLoader';

export const UserEdition = (props, context) => {

    // We check if Component is called form path '/users/new' or path '/users/edit/:id' to define if user is trying to create a new user or editing it.
    const isNewUser = (props.id === undefined)?true:false;
    const [userRol, setUserRol] = useState(null);
      
    // Get "accounts" from Redux.
    const { accounts } =  useSelector(state => state.accounts);

    // Get user and token from Redux
    const { user, token } = useSelector(state => state.user);

    // Get all roles from Redux
    const { roles } = useSelector(state => state.roles);
    
    // State state for "roles" in order to handle user credential acctión (ie: don't creat a new root user if is an Admin user).
    const [ rolesForCombo, setRolesForCombo] = useState([]);
    
    // Variable to show/hide "spinner" while loading page.
    const { isLoading, showSpinner, hideSpinner } = useisLoading(true);

    const [apiUsers, setApiUsers] = useState(null);

    // Stander useForm of react-hook-form Library
    const { register, handleSubmit, getValues, setValue, reset, formState: { errors } } = useForm({

        defaultValues: {
            // User default attribute for creation of new entity
            id: "",
            given_name: "",
            family_name: "",
            password: "",
            confirm_password: "",
            email: "",
            user_name: "",
            enabled: true,
            account_id: "",
            phone_number: "",
            avatar_picture: "",
            role_id: "",
            verified_email: true,

            // FIXME: Eliminate next hardcode parameters and uncomment above.
            // // id: "",
            // given_name: "Test",
            // family_name: "Test",
            // password: "Superman%1",
            // confirm_password: "Superman%1",
            // email: "test@test.com",
            // user_name: "test1uno",
            // enabled: true,
            // // account_id: "",
            // phone_number: "+5491130191155",
            // // role_id: "",
            // verified_email: true,
            
            // backendError is used to set back-end-error message when service has fail (to show to the user)
            backendError: null,
            // onSubmitOk is used to control if onSubmit acction was success.
            onSubmitOk: null,
        }

    });

    const [images, setImages] = React.useState([]);
    const maxNumber = 69;

    const onChangeImage = (imageList, addUpdateIndex) => {
        // data for submit
        console.log(imageList, addUpdateIndex);
        setImages(imageList);
        debugger
        if (imageList[0] && imageList[0].data_url){
            setValue("avatar_picture", imageList[0].data_url);
        } else {
            setValue("avatar_picture", "");
        }
    };

    useEffect(() => {
        
        if(token){
            setApiUsers(new UsersAPI(token))
        }

    }, [token])


    useEffect(() => {

        if (user){
            // Set user role retrieving it from logged user.
            setUserRol(user.roles[0].id);
            // Depending on user roles (ROOT, ADMIN), we set the type of user roles that they can asigne for new users.
            switch (user.roles[0].id) {
                case types.USER_ROOT_ID:
                    // As ROOT user, he can select any role for a new user.
                    setRolesForCombo(roles);
                    break;
                case types.USER_ADMIN_ID:
                    // Remove credential for create new new "root" or "admin" users if logged user is not ROOT.
                    const rolesFiltered = roles.filter(function (e) {
                        return e.name !== "ROOT" && e.name !== "Admin" ;
                    })
                    setRolesForCombo(rolesFiltered);
                default:
                    break;
            }
        }
    }, [user]);  
        
    
    useEffect(() => {

        if(apiUsers){
            if (isNewUser){

                // If user is not a ROOT, we force account id selection.
                if (user.roles[0].id !== types.USER_ROOT_ID){
                    setValue("account_id", user.accounts[0].id);
                }


                // Stop spinnner and render page.
                hideSpinner();
            } else{ // We are "editing" a user.
                showSpinner();
            
                // const userValues = await getUserById(props.id);
                apiUsers.get(encodeURI(props.id)).then( (userValues) => {
        
                    setValue("id", userValues.id);
                    setValue("given_name", userValues.given_name);
                    setValue("family_name", userValues.family_name);
                    setValue("email", userValues.email);
                    setValue("verified_email", userValues.verified_email);
                    setValue("user_name", userValues.user_name);
                    setValue("phone_number", userValues.phone_number);
                    setValue("avatar_picture", userValues.avatar_picture);
                    setValue("enabled", userValues.enabled);
                    setValue("account_id", userValues.accounts[0].id);
                    setValue("role_id", userValues.roles[0].id);
            
                    // Delay a second the selection of "account" and "role" ids selected after both component are loading from wiht their values.
                    setTimeout(() => {
                        
                        reset({ account_id: [userValues.accounts[0].id] });
                        reset({ role_id: [userValues.roles[0].id] });    
                        
                    }, 1000);
    
                }).catch(err => {
                    console.log("Error on loading user information: " + err);
                    // Set "backendError" show a back-end error as message to the user at the top.
                    setValue("backendError",  context.t(err.message) );    
                
                }).finally(() => {
                    // Stop spinnner and render page.
                    hideSpinner();
                });        
            }
        
        }
    }, [apiUsers]);


    // Function calls at form submit
    const onSubmit = data => {
        
        // Show spinner
        showSpinner();
        if (isNewUser){
            
            // Create "new user objet"
            const newUser = new User({
                "account_id" : getValues().account_id,
                "given_name" : getValues().given_name,
                "family_name" : getValues().family_name,
                "email" : getValues().email,
                "verified_email": getValues().verified_email,
                "user_name" : getValues().user_name,
                "password" : getValues().password,
                "phone_number" : getValues().phone_number,
                "avatar_picture" : getValues().avatar_picture,
                "enabled" : getValues().enabled,
                "rol_id" : parseInt(getValues().role_id),
                "connection": "Username-Password-Authentication"
            });
                            
            // Call function to create "new" user
            apiUsers.create(newUser, context).then(() => {
                
                // Set onSubmitOk in "true" in order to redirect to the user list after crete the new user.
                setValue("onSubmitOk",  true );

                // Stop spinnner and render page.
                hideSpinner();
                
                message(context.t("User creation"), context.t("User created successfully"));
            
            }).catch(err => {
                console.log("NewUser onSubmit error: " + err);
                // Set "backendError" show a back-end error as message to the user at the top.
                setValue("backendError", context.t(err.message));
                
            }).finally( () =>{
                // Stop spinnner and render page.
                hideSpinner();
            });

        } else { // It's a user edition.

            // Show spinner
            showSpinner();
            
            console.log("getValues().id: " + getValues().id);
            debugger
            // Create "new user objet"
            const userToModify = new User({
                "id": getValues().id,
                // "account_id" : parseInt(getValues().account_id),
                "account_id" : parseInt(getValues().account_id),
                "given_name" : getValues().given_name,
                "family_name" : getValues().family_name,
                // "email" : getValues().email,
                "verified_email": getValues().verified_email,
                "user_name" : getValues().user_name,
                // "password" : getValues().password,
                "phone_number" : getValues().phone_number,
                "avatar_picture" : getValues().avatar_picture,
                
                // "avatar_picture" : "file:///C:/Users/sevalles/OneDrive%20-%20Swiss%20Medical%20S.A/Im%C3%A1genes/Seba%20Frente%202022.jpg",

                "enabled" : true, // getValues().enabled,
                "rol_id" : parseInt(getValues().role_id), // rol_id instead role_id because backend service is bad formatted (whit sintaxis error)
                // "connection": "Username-Password-Authentication"
            });
            
            // Call function to create "new" user
            apiUsers.update(userToModify).then(() => {        
                // Set onSubmitOk in "true" in order to redirect to the user list after update the user values.
                setValue("onSubmitOk",  true );
                message(context.t("User update"), context.t("Update done successfully"));

            }).catch(err => {
                console.log("EdithUser onSubmit error: " + err);
                // Set "backendError" show a back-end error as message to the user at the top.
                setValue("backendError",  context.t(err.message) );
            
            }).finally( () =>{
                // Stop spinnner and render page.
                hideSpinner();
            });
        } // End Else
    };
        
    // If OnSubmit was success, redirect to user list
    if (getValues().onSubmitOk){
        return <Redirect to='/users' />
    }

    if (isLoading) {
        return <Loading/>
    } else {
        return (
            <Container fluid>
                {/* If "backendError" has value, it shows to the user */}
                <ErrorMessage message={getValues().backendError}/>

                {/* Page header has Title and Subtite of the page */}
                <PageHeaderStandar title={context.t('User')} subtitle={ (isNewUser)?context.t('Add'):context.t('Edit') } />

                <Card small="true" style={{ marginBottom: '20px'}}>
                    <Form validate="true" onSubmit={ handleSubmit(onSubmit) } style={{ padding: "10px"}}>
                    <input type={'hidden'} {...register("id")} />
                    <Row>
                        <Col lg="6">
                        <InputField type="text"
                            label= { context.t('First Name') }
                            name="given_name"
                            placeholder={ context.t('John') }
                            errors={errors} 
                            useFormRegister= {
                            register("given_name", { 
                                required: context.t("This is required"), 
                                pattern: {
                                value: regexStandardName(),
                                message: context.t("Value entered is not allowed"),
                                }
                            })
                            }
                        />

                        <InputField label={context.t('Last Name')} name="family_name" placeholder={context.t('Doe')} 
                            errors={errors} 
                            useFormRegister= {
                            register("family_name", { 
                                required: context.t("This is required"), 
                                pattern: {
                                value: regexStandardName(),
                                message: context.t("Value entered is not allowed"),
                                }
                            })
                            }
                        />

                        {
                            (isNewUser)?(
                                <>
                                    <InputField label={context.t('Password')} type="password" name="password" placeholder={context.t('********')} 
                                        errors={errors} 
                                        useFormRegister= {
                                        register("password", { 
                                            required: context.t("This is required"),
                                            pattern: {
                                            value: regexPassword(), // eslint-disable-line 
                                            message: context.t("Password must be between 8 and 30 characters, at least one uppercase, one lowercase and one special character"),
                                            }
                                        })
                                        }
                                    />

                                    <InputField label={context.t('Confirm Password')} type="password" name="confirm_password" placeholder={context.t('********')} 
                                        errors={errors} 
                                        useFormRegister= {
                                        register("confirm_password", { 
                                            required: context.t("This is required"), 
                                            validate: {
                                            identicalPasswords: value => (value === getValues().password) || context.t("Passwords must be the same"), 
                                            },
                                        })
                                        }
                                    />
                                </>
                            ):(null)
                        }

                        <InputField label={context.t('Email')} name="email" placeholder={context.t('your@email.com')} 
                            errors={errors} 
                            useFormRegister= {
                            register("email", { 
                                required: context.t("This is required"), 
                                validate: {
                                emailValidation: v => isEmail(v) || context.t("Email value is not valid"),
                                uniqueEmail: v => true || "TODO: Generar servicos e invicar desde aquí para validad unicidad del mail",
                                },
                            })
                            }
                        />

                        <InputField label={context.t('Phone')} name="phone_number" placeholder={context.t('1-541-754-3010')} 
                            errors={errors} 
                            useFormRegister= {
                            register("phone_number", { 
                                required: false, 
                                validate: {
                                phoneNumber: value => ((value === "")?true:isMobilePhone(value)) || context.t("Phone value is not valid (Valid example: +5491144445555)"),
                                },
                            })
                            }
                        />
                        </Col>
                        <Col lg="6">

                        <InputField label={context.t('User Name')} name="user_name" placeholder={context.t('john.doe')} 
                            errors={errors} 
                            useFormRegister= {
                            register("user_name", { 
                                required: context.t("This is required"), 
                                pattern: {
                                value: regexUserName(),
                                message: context.t("Username must be 8-15 alphanumeric characters"),
                                },
                                validate: {
                                uniqueUserName: v => true || "TODO: Generar servicos e invicar desde aquí para validad unicidad del username",
                                },
                            })
                            }
                        />

                        {
                            (isNewUser && userRol === types.USER_ROOT_ID)?( // Only ROOT user must select Account for a new user.
                                <SelectCombobox
                                    name= "account_id" 
                                    label={ context.t('Account') }
                                    valueOptions={ accounts } 
                                    // disabled={true}
                                    errors={ errors }
                                    useFormRegister= {
                                        register("account_id", {        
                                            required: context.t("Must select an option"),
                                        })
                                    }
                                />
                            ):(
                                <SelectCombobox
                                    name= "account_id" 
                                    label={ context.t('Account') }
                                    valueOptions={ accounts } 
                                    valueSelected={getValues().account_id}
                                    // disabled={true}
                                    useFormRegister= {
                                        register("account_id", {        
                                            required: context.t("Must select an option"),
                                        })
                                    }
                                />
                            )
                        }                            

                        <SelectCombobox
                            name= "role_id" 
                            label={ context.t('Role') }
                            valueOptions={ rolesForCombo } 
                            disabled={false}
                            errors={ errors }
                            useFormRegister= {
                            register("role_id", { 
                                value: getValues().role_id,
                                required: context.t("Must select an option"), 
                            })
                            }
                        />
                        {/* Next line were commented in order to avoid unnecessary complexitNext line were commented in order to avoid unnecessary complexity to handle user "activation/inactivation". As MVP, an obsolete user should be "removed" and not inactivated */}
                        <Checkbox label={context.t('Enabled')} disabled={true} name="enabled" useFormRegister= {register("enabled", {})}  />

                        <Checkbox label={context.t('Verified email')} name="verified_email" useFormRegister= {register("verified_email", {})}  />

                        <ImageUploading
                            // multiple
                            value={images}
                            onChange={onChangeImage}
                            maxNumber={maxNumber}
                            dataURLKey="data_url"
                        >
                            {({
                                imageList,
                                onImageUpload,
                                onImageRemoveAll,
                                onImageUpdate,
                                onImageRemove,
                                isDragging,
                                dragProps,
                            }) => (
                                // write your building UI
                                <div className="upload__image-wrapper">
                                    <Button variant="outline-secondary mb-2 mr-1" 
                                    
                                        style={isDragging ? { color: 'red' } : undefined}
                                        onClick={onImageUpload}
                                        {...dragProps}
                                        >{context.t('Add Photo')}</Button>
                                    &nbsp;
                                    {imageList.map((image, index) => (
                                        <div key={index} className="image-item">
                                            <img src={image['data_url']} alt="" width="100" />
                                            <br/>
                                            <div className="image-item__btn-wrapper">
                                                <Button variant="outline-secondary mb-2 mr-1" onClick={() => onImageUpdate(index)}>Update</Button>
                                                <Button variant="outline-secondary mb-2 mr-1" onClick={() => onImageRemove(index)}>Remove</Button>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            )}
                        </ImageUploading>
                        </Col>
                    </Row>
                    <hr/>
                    <ButtonsSaveAndCancel/>
                    </Form>
                </Card>
            </Container>
        )
    }
}


UserEdition.contextTypes = {
    t: PropTypes.func
}

export default UserEdition